var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "users-maintenance" },
    [
      _vm.showSpinner
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _vm._e(),
      _vm.isGridRenderMode
        ? _c("UsersMaintenanceGridComponent", {
            attrs: {
              itemsData: _vm.usersData,
              listConfiguration: _vm.listConfiguration,
              context: _vm.context,
              headerTitle: _vm.headerTitle,
            },
            on: { openFormEvent: _vm.onformOpenEvent },
          })
        : _vm._e(),
      _vm.isTabRenderMode
        ? _c("UserManintenanceTabsComponent", {
            attrs: {
              userData: _vm.selectedRegister,
              headerTitle: _vm.headerTitle,
            },
            on: {
              closeTabsEvent: _vm.onCloseTabsEvent,
              saveFormEvent: _vm.onSaveFormEvent,
              hideFatherComponentSpinnerEvent:
                _vm.onHideFatherComponentSpinnerEvent,
              saveOnFormTabChangeEvent: _vm.onSaveOnFormTabChangeEvent,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }